import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';

export const PLAN_NOTICES_INTRO =
  'Coverage elections, effective dates, eligibility, and premiums are governed by the official Plan Documents / Summary Plan Description (SPD), administrative service agreements, and applicable federal and state laws. In the event of any discrepancy between enrollment materials and official plan documents, the official plan documents control.';

export const PLAN_NOTICES = [
  {
    title: 'HIPAA Privacy Notice',
    body: 'Protected Health Information (PHI) collected during enrollment is handled in accordance with the HIPAA Privacy and Security Rules. You may request a copy of the applicable Notice of Privacy Practices at any time.',
  },
  {
    title: 'Section 125 / Cafeteria Plan Notice',
    body: 'Pre-tax benefit elections are generally irrevocable during the plan year unless you experience a qualifying life event under Section 125 of the Internal Revenue Code and the Plan’s governing documents.',
  },
  {
    title: 'COBRA Continuation Coverage Notice',
    body: 'Certain employees, spouses, and dependents may have the right to continue health coverage under COBRA following qualifying events. Rights, timelines, and eligibility requirements are governed by federal law and your plan.',
  },
];

export function PlanNotices() {
  return (
    <section className={`rounded-2xl border border-neutral-200 bg-white p-6 ${POSTHOG_UNMASK_CLASS}`}>
      <h2 className='text-sm font-semibold text-[var(--enroll-ink)]'>Plan notices</h2>
      <p className='mt-2 text-xs leading-relaxed text-neutral-500'>{PLAN_NOTICES_INTRO}</p>
      <dl className='mt-4 space-y-3'>
        {PLAN_NOTICES.map((notice) => (
          <div key={notice.title}>
            <dt className='text-xs font-semibold text-neutral-700'>{notice.title}</dt>
            <dd className='mt-0.5 text-xs leading-relaxed text-neutral-500'>{notice.body}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
